import PDVGrande from '../public/icons/Grande/PDV.svg'
import V4Grande from '../public/icons/Grande/V4.svg'
import TouchOneGrande from '../public/icons/Grande/TouchOne.svg'
import ParkGrande from '../public/icons/Grande/Park.svg'
import MobileGrande from '../public/icons/Grande/Mobile.svg'
import PDVPequeno from '../public/icons/Pequeno/PDV.svg'
import V4Pequeno from '../public/icons/Pequeno/V4.svg'
import TouchOnePequeno from '../public/icons/Pequeno/TouchOne.svg'
import ParkPequeno from '../public/icons/Pequeno/Park.svg'
import MobilePequeno from '../public/icons/Pequeno/Mobile.svg'

export const IconsGrande = () => {
    return {
        PDVGrande,
        V4Grande,
        TouchOneGrande,
        ParkGrande,
        MobileGrande
    }
}

export const IconsPequeno = () => {
    return {
        PDVPequeno,
        V4Pequeno,
        TouchOnePequeno,
        ParkPequeno,
        MobilePequeno
    }
}